import { IEventAggregator } from '@classic/AppUtils/Framework/Messaging/IEventAggregator'
import container from '@classic/AppUtils/Framework/IOC/inversify.config'

type UseEventAggregator = IEventAggregator

export function useEventAggregator(): UseEventAggregator {
  return container.get<IEventAggregator>('IEventAggregator')
}
